import React from "react";
import { goals } from "../mock";
import { Dumbbell, HeartPulse, House, Building2, ArrowRight } from "lucide-react";
import useReveal from "../hooks/useReveal";

const icons = { Dumbbell, HeartPulse, House, Building2 };

export default function ShopByGoal() {
  const ref = useReveal();
  return (
    <section className="bg-white py-16">
      <div ref={ref} className="reveal mx-auto max-w-7xl px-4 lg:px-8">
        <div className="mb-8 text-center">
          <h2 className="font-heading text-2xl font-extrabold text-navy md:text-3xl">
            Shop by Goal
          </h2>
          <p className="mt-2 text-sm text-navy/60">
            Not sure where to start? Pick your goal and we&rsquo;ll point you in the right direction.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
          {goals.map((g) => {
            const Icon = icons[g.icon];
            return (
              <a
                key={g.id}
                href="#categories"
                className="group relative flex flex-col items-center overflow-hidden rounded-2xl bg-navy p-8 text-center transition-all hover:-translate-y-1"
              >
                <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-white/10 text-brand transition-colors group-hover:bg-brand group-hover:text-white">
                  <Icon size={30} />
                </div>
                <h3 className="font-heading text-lg font-bold text-white">{g.title}</h3>
                <p className="mt-1 text-xs text-white/60">{g.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-xs font-bold uppercase tracking-wide text-brand transition-all group-hover:gap-2">
                  Shop now <ArrowRight size={13} />
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
